import luffy from '../assets/Img/luffy.jpg'
import nami from '../assets/Img/nami.jpg'
import zoro from '../assets/Img/zoro.jpg'
import sanji from '../assets/Img/sanji.jpg'
import jinbe from '../assets/Img/jinbe.jpg'
import brook from '../assets/Img/brook.jpg'
import franky from '../assets/Img/franky.jpg'
import robin from '../assets/Img/robin.jpg'
import chopper from '../assets/Img/chopper.jpg'
import ussop from '../assets/Img/ussop.jpg'

export const items = [
    {name: 'luffy', icon: luffy },
    {name: 'nami', icon: nami },
    {name: 'zoro', icon: zoro },
    {name: 'sanji', icon: sanji },
    {name: 'jinbe', icon: jinbe },
    {name: 'brook', icon: brook },
    {name: 'franky', icon: franky},
    {name: 'robin', icon: robin },
    {name: 'chopper', icon: chopper },
    {name: 'ussop', icon: ussop },

    

]